import { render, staticRenderFns } from "./vpfDeclaration.vue?vue&type=template&id=ea98ed6e&scoped=true"
import script from "./vpfDeclaration.vue?vue&type=script&lang=js"
export * from "./vpfDeclaration.vue?vue&type=script&lang=js"
import style0 from "./vpfDeclaration.vue?vue&type=style&index=0&id=ea98ed6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea98ed6e",
  null
  
)

export default component.exports